import { User } from "@/core/models/global/User";
import { UserResponse } from "./UserResponse";
import { __UserResponseInternals } from "./UserResponse";

const { BaseObject, toUserInstance } = __UserResponseInternals;

export class RegisterResponse extends UserResponse {
    constructor(args: { user?: User; token?: string }) {
        super("register", args.user, args.token);
    }

    // Produces a RegisterResponse instance
    static schema = BaseObject.transform((raw) => {
        const token = (raw as any).token as string | undefined;
        const user = toUserInstance((raw as any).user);
        return new RegisterResponse({ token: token, user: user });
    });

    static fromJSON(raw: unknown): RegisterResponse {
        return RegisterResponse.schema.parse(raw);
    }
}
